import React from "react";

import { PageLoading as BasePageLoading, PageLoadingProps } from "@packages/ds";
import { FormattedMessage } from "react-intl";

type ConsolePageLoadingProps = Omit<PageLoadingProps, "loadingText">;

const PageLoading = (props: ConsolePageLoadingProps) => (
  <BasePageLoading {...props} loadingText={<FormattedMessage id="loading" />} />
);

export default PageLoading;
